import { MutationTree, GetterTree } from 'vuex';
import { State, Data } from '@root/modules/article/types/article';

export const state: () => State = () => ({
  articlesWithBodyContent: [],
  crArticles: [],
  activeArticleId: null,
  activeArticle: null,
  activeArticlePath: null,
  articleExtraContent: null,
  articleTopHeadlines: null,
  articleCxenseArticles: null,
  articleCxenseHeadlines: null,
  articlePtHeadlines: null,
  tempData: null,
  preFetch: false,
  isMultipage: false,
  scrollDirection: null,
});

export const getters: GetterTree<State, Record<string, unknown>> = {
  getTempData: (state) => state.tempData,
  getBodyContentStatus: (state) => (articleId: string) => {
    return state.articlesWithBodyContent.find((id) => id === articleId);
  },
  getCrArticles: (state) => {
    return state.crArticles;
  },
  getActiveArticleId: (state) => state.activeArticleId,
  getActiveArticle: (state) => state.activeArticle,
  getActiveArticlePath: (state) => state.activeArticlePath,
  getArticleExtraContent: (state) => state.articleExtraContent,
  getArticleTopHeadlines: (state) => state.articleTopHeadlines,
  getArticleCxenseArticles: (state) => state.articleCxenseArticles,
  getArticleCxenseHeadlines: (state) => state.articleCxenseHeadlines,
  getArticlePtHeadlines: (state) => state.articlePtHeadlines,
  isMultipage: (state) => state.isMultipage,
};

export const mutations: MutationTree<State> = {
  setCrArticles(state, crArticles: string[] | []) {
    state.crArticles = crArticles;
  },
  setActiveArticleId(state, articleId: string) {
    state.activeArticleId = articleId;
  },
  setActiveArticlePath(state, articlePath: string) {
    state.activeArticlePath = articlePath;
  },
  setActiveArticle(state, article: Data) {
    state.activeArticle = article;
  },
  setArticleExtraContent(state, extraContent: State['articleExtraContent']) {
    state.articleExtraContent = extraContent;
  },
  setArticleTopHeadlines(state, topHeadlines: State['articleTopHeadlines']) {
    state.articleTopHeadlines = topHeadlines;
  },
  setArticleCxenseArticles(state, cxenseArticles: State['articleCxenseArticles']) {
    state.articleCxenseArticles = cxenseArticles;
  },
  setArticleCxenseHeadlines(state, cxenseHeadlines: State['articleCxenseHeadlines']) {
    state.articleCxenseHeadlines = cxenseHeadlines;
  },
  setArticlePtHeadlines(state, ptHeadlines: State['articlePtHeadlines']) {
    state.articlePtHeadlines = ptHeadlines;
  },
  setTempData(state, value: State['tempData']) {
    state.tempData = {
      article: value?.article || null,
      access: value?.access || false,
      articleToken: value?.articleToken || null,
    };
  },
  resetTempData(state) {
    state.tempData = null;
  },
  setPreFetch(state, value: boolean) {
    state.preFetch = value;
  },
  setIsMultipage(state, value: boolean) {
    state.isMultipage = value;
  },
  setScrollDirection(state, value: string) {
    state.scrollDirection = value;
  },
};
